import client from './client'
import type { EventEmailSettings, UpdateEventEmailSettingsPayload } from '@/types/event-email-settings'

export async function getEventEmailSettings(eventSlug: string): Promise<EventEmailSettings> {
  const { data } = await client.get<{ data: EventEmailSettings }>(
    `/organizer/events/${eventSlug}/email-settings`,
  )
  return data.data
}

export async function updateEventEmailSettings(
  eventSlug: string,
  payload: UpdateEventEmailSettingsPayload,
): Promise<EventEmailSettings> {
  const { data } = await client.put<{ data: EventEmailSettings }>(
    `/organizer/events/${eventSlug}/email-settings`,
    payload,
  )
  return data.data
}
